import { Box, Button, Group, Modal, Text } from "@mantine/core";
import { Person } from "../../../models/person.model";

interface DeleteConfirmModalProps {
    opened: boolean;
    personToDelete: Person | null;
    onClose: () => void;
    onConfirm: () => void;
}

export function DeleteConfirmModal({
    opened,
    personToDelete,
    onClose,
    onConfirm,
}: DeleteConfirmModalProps) {
    return (
        <Modal
            opened={opened}
            onClose={onClose}
            title="Confirm Deletion"
            size="sm"
        >
            <Box p="md">
                <Text size="sm" mb="xl">
                    Are you sure you want to delete{" "}
                    {personToDelete
                        ? `${personToDelete.firstName} ${personToDelete.lastName}'s`
                        : ""}{" "}
                    CV? This action cannot be undone.
                </Text>
                <Group justify="right" mt="md">
                    <Button
                        variant="outline"
                        color="gray"
                        onClick={onClose}
                    >
                        Cancel
                    </Button>
                    <Button color="red" onClick={onConfirm}>
                        Delete
                    </Button>
                </Group>
            </Box>
        </Modal>
    );
}

